import React from 'react';
import './ActivityGridSettings.css';

const ActivityGridSettings = ({ settings, onSettingsChange }) => {
    if (!settings) {
        console.error('Settings prop is undefined');
        return null;
    }

    const handleColorChange = (colorType, value) => {
        onSettingsChange({
            ...settings,
            colors: {
                ...settings.colors,
                [colorType]: value
            }
        });
    };

    const handleTitleChange = (e) => {
        onSettingsChange({
            ...settings,
            title: e.target.value
        });
    };

    const handleDateRangeChange = (type, value) => {
        onSettingsChange({
            ...settings,
            dateRange: {
                ...settings.dateRange,
                [type]: value
            }
        });
    };

    return (
        <div className="settings-panel">
            <div className="settings-section">
                <h3>Colors</h3>
                <div className="color-input">
                    <label>Background:</label>
                    <input
                        type="color"
                        value={settings.colors.background}
                        onChange={(e) => handleColorChange('background', e.target.value)}
                    />
                </div>
                <div className="color-input">
                    <label>Card Background:</label>
                    <input
                        type="color"
                        value={settings.colors.cardBackground}
                        onChange={(e) => handleColorChange('cardBackground', e.target.value)}
                    />
                </div>
                <div className="color-input">
                    <label>Text Color:</label>
                    <input
                        type="color"
                        value={settings.colors.text}
                        onChange={(e) => handleColorChange('text', e.target.value)}
                    />
                </div>
                <div className="color-input">
                    <label>Route Color:</label>
                    <input
                        type="color"
                        value={settings.colors.polyline}
                        onChange={(e) => handleColorChange('polyline', e.target.value)}
                    />
                </div>
            </div>

            <div className="settings-section">
                <h3>Title</h3>
                <input
                    type="text"
                    value={settings.title}
                    onChange={handleTitleChange}
                    placeholder="Enter title"
                />
            </div>

            <div className="settings-section">
                <h3>Date Range</h3>
                <div className="date-inputs">
                    <div className="date-input">
                        <label>Start Date:</label>
                        <input
                            type="date"
                            value={settings.dateRange.start ? new Date(settings.dateRange.start).toISOString().split('T')[0] : ''}
                            onChange={(e) => handleDateRangeChange('start', new Date(e.target.value))}
                        />
                    </div>
                    <div className="date-input">
                        <label>End Date:</label>
                        <input
                            type="date"
                            value={settings.dateRange.end ? new Date(settings.dateRange.end).toISOString().split('T')[0] : ''}
                            onChange={(e) => handleDateRangeChange('end', new Date(e.target.value))}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ActivityGridSettings; 